<template>
	<div class="plug-tree">
		<div class="topCut" >
			<span class="title">{{title?title:'是否查询下级'}}</span>
			<span v-if="showSwitch">
				<el-tooltip :content="'当前查询状态: ' + newSwitchVal?'查询下级区域':'查询本级区域'" placement="top">
					<el-switch @change="changeSwitch" v-model="newSwitchVal" active-color="#13ce66" inactive-color="#ff4949">
					</el-switch>
				</el-tooltip>
			</span>
		</div>
		<div style="overflow: auto;height:calc(100% - 40px)">
			<el-tree :props="props" ref="nodeTree" :highlight-current="true" :current-node-key="nodeId"  node-key="id" @node-click="nodeClick" :load="loadNode" lazy> </el-tree>
		</div>
	</div>
</template>

<script>
	import publicAPI from '../../api-path/public-api'
	export default {
		name: "tree",
		props: {
			switchVal: {
				type: Boolean,
				default: false
			},
			showSwitch: {
				type: Boolean,
				default: true,
			},
			title: {
				type: String,
				default: '是否查询下级',
			},
			isfirstChoice: {
				type: Boolean,
				default: true,
			},
			areaId:{
				type:String
			}
		},
		data() {
			return {
				newSwitchVal: false,
				areaTreeList:[],
				nodeId: '0',
				props: {
					label: 'name',
					key: 'id',
					children: 'areaTreeListResList',
					isLeaf: 'isLast'
				},
				nowAreaId:''
			}
		},
		created() {

			if (this.switchVal) {
				this.newSwitchVal = this.switchVal === this.newSwitchVal ? this.newSwitchVal : this.switchVal
			}
		},

		methods: {
			loadNode(node, resolve) {
				if(!this.areaId){
					this.nowAreaId=localStorage.getItem('centerId')?localStorage.getItem('centerId'):'0';
				}else{
					this.nowAreaId=this.areaId;
				}
				let $this=this;
				if (node.level === 0) {
					let areaId= this.nowAreaId;
					$this.$http.get(publicAPI.meetingListTree,{params: { id: areaId ,type:0}}).then(res => {
						if (res.status==200) {
							$this.areaTreeList=res.result.areaTreeListResList;
							if(this.isfirstChoice){
								setTimeout(function () {
									$this.$nextTick(function () {
										this.nodeId=res.result.id;
										let result=JSON.parse(JSON.stringify(res.result));
										console.log(res.result);
										$this.$refs.nodeTree.setCurrentKey(this.nodeId)
										if(!res.result.id){
											result.id='';
											result.name='';
										}
										$this.$emit('nodeClick', result)
									})
								},1000)
							}
							return resolve([res.result]);
						}
					})
				}
				if (node.level ==1) {
					return resolve(this.areaTreeList);
				}
				if (node.level > 1) {
					this.loadchildnode(node, resolve);
				}
			},
			loadchildnode(node, resolve) {
				this.$http.get(publicAPI.meetingListTree, {
					params: { id: node.data.id ,type:1}
				}).then(res => {
					if (res.status==200) {
						return resolve(res.result.areaTreeListResList);
					}
				})
			},
			changeSwitch(e) {
				this.$emit('changeSwitch', e)
				sessionStorage.setItem('switch',e);
			},
			nodeClick(node) {
				this.$emit('nodeClick', node);
			}
		}
	}
</script>

<style lang="less" scoped>
	.plug-tree {
		width: 260px;
		height: 100%;
		.topCut {
			display: flex;
			padding: 5px;
			flex-direction: row;
			justify-content: space-between;
			height: 30px;
			background: #e3f7fc;
			color: #666;
			line-height: 30px;
			text-align: center;
			font-size: 14px;
			.title{
				width: 100%;
				text-align: center;
				display: inline-block;
			}
		}
	}
</style>
